// extracted by mini-css-extract-plugin
export var arrows = "_28-6";
export var decrementer = "_28-a";
export var disabled = "_28-4";
export var error = "_28-1";
export var hiddenText = "_28-b";
export var incrementer = "_28-9";
export var input = "_28-8";
export var inputWrapper = "_28-0";
export var leadingIcon = "_28-c";
export var readonly = "_28-3";
export var regular = "_28-7";
export var small = "_28-5";
export var warning = "_28-2";